<template>
    <div class="page-bg login">
        <v-container fill-height justify-center>
            <div class="login-block">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <v-form class="login-frm">
                    <v-row>
                        <v-col class="pad-zero" cols="12" sm="12">
                            <v-select
                                v-model="selectedClass"
                                @change="getSubjects()"
                                :items="classes"
                                label="Category"
                                hide-details
                                item-text="title"
                                item-value="id"
                                dense
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.dataType" />
                        </v-col>
                        <v-col class="pad-zero" cols="12" sm="12">
                            <v-select
                                v-model="selectedSubject"
                                :items="subjects"
                                label="Subjects"
                                item-text="title"
                                item-value="id"
                                hide-details
                                dense
                                multiple
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.subjects" />
                        </v-col>
                        <!-- 
                        <v-col cols="12" sm="12">
                            <v-select
                                v-model="selectedCenterId"
                                :items="centers"
                                label="Select Center"
                                item-text="name"
                                @change="onCenterchange"
                                item-value="id"
                                hide-details
                                dense
                                multiple
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.center" />
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-select
                                v-model="selectedBatch"
                                @change="onBatchSelect"
                                :items="batch"
                                label="Select Batch"
                                item-text="name"
                                item-value="id"
                                hide-details
                                dense
                                multiple
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.batch" />
                        </v-col> -->

                        <v-col class="pad-zero" cols="12" sm="12">
                            <div class="select-center-blk">
                                <div class="teacher-border">
                                    <div
                                        v-if="selectedCenterList.length"
                                        class="selectedCenterListouter"
                                        id="centerContainer"
                                    >
                                        <div
                                            v-for="center in selectedCenterList"
                                            class="selectedCenterList"
                                            :id="center.class"
                                        >
                                            <div class="center-name-v">
                                                {{ center.text }}
                                            </div>

                                            <div class="radio-center">
                                                <div
                                                    class="check-cust center-check"
                                                    v-for="batch in center.batches"
                                                    :title="batch.text"
                                                >
                                                    <v-checkbox
                                                        v-model="batch.checked"
                                                        :label="batch.text"
                                                        :disabled="
                                                            batch.disabled
                                                        "
                                                        dense
                                                        hide-details
                                                    ></v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            class="select-center cp3-select-center"
                                        >
                                            <v-select
                                                :items="centers"
                                                v-model="selectedCenterId"
                                                hide-details
                                                no-data-text="No centers available"
                                                dense
                                                class="required"
                                                filled
                                                solo
                                                attach
                                                auto
                                                placeholder="Add Center & Batch"
                                            ></v-select>
                                        </div>
                                    </div>
                                </div>
                                <InputError :data="error.batches" />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary sign-up-terms top-0">
                                <div class="user-new-signup">
                                    <div class="user-terms-block" v-if="showPrivacyAndTerms">
                                        <div class="user-terms-check">
                                            <v-checkbox
                                                input-value=""
                                                value
                                                v-model="ischecked"
                                            ></v-checkbox>
                                        </div>
                                        <div class="user-terms-text-outer">
                                            <div class="user-terms-text">
                                                I accept the
                                                <a @click="termandcondition"
                                                    >Terms of Service</a
                                                >
                                                and
                                                <a @click="privacyPolicy"
                                                    >Privacy Policy</a
                                                >
                                            </div>
                                        </div>
                                        <InputError :data="error.ischecked" />
                                    </div>
                                </div>

                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="onSubmit"
                                        class="right-btn cust-btn"
                                        color="primary"
                                        >Done</v-btn
                                    >
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
                    <img
                        src="../../../assets/img/logo-footer.png"
                        class="master-logo"
                    />
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
    name: "TeacherSignupStep2",
    data() {
        return {
            loading: false,
            classes: [],
            subjects: [],
            selectedClass: null,
            selectedSubject: null,
            page: 1,
            teacherEmail: null,
            teacherName: null,
            logo: this.getInstituteLogo(),
            centers: [],
            batch: [],
            selectedCenterId: [],
            selectedBatch: [],
            error: {
                dataType: {
                    type: null,
                    message: "Please select target year",
                },
                subjects: {
                    type: null,
                    message: "Please select subject",
                },
                batches: {
                    type: null,
                    message: "Please Select Batch",
                },
                ischecked: {
                    type: null,
                    message:
                        "Please accept Terms & Conditions and Privacy Policy",
                },
            },
            selectedCenterList: [],
            selectedCenterId: null,
            showAddcenterButton: true,
            ischecked: false,
			showPrivacyAndTerms:true
        };
    },
    methods: {
        ...mapActions({
            signUp: "userStore/signUp",
            getUserByEmail: "userStore/getUserByEmail",
            getClasses: "utilStore/getClasses",
            getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
            getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic",
            getCenters: "centerAndBatchStore/getCenters",
            getBatches: "centerAndBatchStore/getBatchesPublic", // public signup: token-less batch endpoint
        }),
        requestGetClasses() {
            this.getDataTreeWithLevelPublic({ level: 1 })
                .then((response) => {
                    this.loading = false;
                    this.classes = response;
                })
                .catch((err) => {
                    console.log(err);

                    this.loading = false;
                });
        },
        getSubjects() {
            this.subjects = [];
            this.selectedSubject = null;
            this.getDataTreeWithLevelPublic({
                level: 2,
                parent: this.selectedClass,
            })
                .then((response) => {
                    this.$root.showLoader = false;
                    this.subjects = response;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        validate() {
            let isValid = true;
            let batches = [];
            this.error.batches.type = null;
            this.error.ischecked.type = null;

            this.selectedCenterList.map((sc) => {
                return sc.batches.map((b) => {
                    if (b.checked) {
                        batches.push(b.value);
                    }
                });
            });
            if (!this.selectedClass) {
                this.$toasted.error(`Please select target year`);
                isValid = false;
            } else if (!this.selectedSubject) {
                this.$toasted.error(`Please select subject`);
                isValid = false;
            }
            if (!batches || batches.length <= 0) {
                this.error.batches.type = "error";
                isValid = false;
            }
            if (!this.ischecked && this.showPrivacyAndTerms) {
                this.error.ischecked.type = "error";
                isValid = false;
            }
            return isValid;
        },
        onSubmit() {
            if (this.validate()) {
                this.$root.showLoader = true;
                let me = this;
                let className = this.classes[
                    this.classes.findIndex((x) => x.id === this.selectedClass)
                ].title;
                let batches = [];
                this.selectedCenterList.map((sc) => {
                    return sc.batches.map((b) => {
                        if (b.checked) {
                            batches.push(b.value);
                        }
                    });
                });
                this.signUp({
                    ...this.signUpData,
                    class: className,
                    categories: this.selectedSubject,
                    batches: batches,
                })
                    .then((response) => {
                        this.$root.showLoader = false;
                        this.$toasted.success(`Success\n${response.message}`, {
                            icon: "check_circle", className:'new-class'
                        });
                        this.$router.push({ name: "login" }).catch(() => {});
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            }
        },

        requestGetCenters(alreadySelectedCenter) {
            this.centers = [];
            this.$root.showLoader = true;
            this.getCenters()
                .then((response) => {
                    this.$root.showLoader = false;
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                    this.centers = this.centers.filter((c) => {
                        return alreadySelectedCenter.indexOf(c.value) === -1;
                    });
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onCenterchange(centerIds) {
            this.selectedCenterId = centerIds;
            this.requestGetBatch(centerIds);
        },
        requestGetBatch(centerId) {
            let reqData = {
                center_id: [centerId],
            };

            this.getBatches(reqData)
                .then((response) => {
                    this.loading = false;
                    let tmpCenter = this.centers.filter(
                        (x) => x.value === centerId
                    );
                    if (response && response.list && response.list.length) {
                        let tmpBatch = response.list.map((x) => {
                            let c = {};
                            c.text = x.name;
                            c.value = x.id;
                            c.checked = false;
                            c.subject_id = x.subject_ids
                                .split(",")
                                .map((s) => parseInt(s));
                            return c;
                        });

                        let maxIdx = this.selectedCenterList.length;
                        this.selectedCenterList.push({
                            ...tmpCenter[0],
                            batches: tmpBatch,
                            class: maxIdx + "center",
                        });

                        this.selectedCenterList.sort(function(a, b) {
                            var nameA = a.text.toLowerCase(),
                                nameB = b.text.toLowerCase();
                            if (nameA < nameB) return -1;
                            if (nameA > nameB) return 1;
                            return 0;
                        });
                        this.centers = this.centers.filter(
                            (x) => x.value !== centerId
                        );
                        this.disableBatches();
                    } else {
                        this.$toasted.error(
                            `Batches not available for center ${tmpCenter[0].text}`,
                            { icon: "info" }
                        );
                        this.centers = this.centers.filter(
                            (x) => x.value !== centerId
                        );
                        //   this.selectedCenterList.push({
                        //         ...tmpCenter[0],
                        //         batches: []

                        //     })

                        //     this.centers = this.centers.filter(x => x.value !== centerId)
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        onBatchSelect(batchId) {
            this.selectedBatch = batchId;
        },
        testLogicForScroll() {
            var elem = document.getElementById(
                this.selectedCenterList.length - 1 + "center"
            );
            elem.scrollIntoView();
        },
        disableBatches() {
            this.selectedCenterList.map((center) => {
                center.batches.map((b) => {
                    if (this.selectedSubject && this.selectedSubject.length) {
                        b.disabled = !(
                            this.selectedSubject.findIndex((s) =>
                                b.subject_id.includes(s)
                            ) >= 0
                        );
                    } else {
                        b.disabled = true;
                    }
                });
            });
        },
        termandcondition() {
            let routeData = this.$router.resolve({
                name: "terms-and-conditions",
            });
            window.open(routeData.href, "_blank");
        },
        privacyPolicy() {
            let routeData = this.$router.resolve({ name: "privacy-policy" });
            window.open(routeData.href, "_blank");
        },
    },
    computed: {
        ...mapState("userStore", ["signUpData", "isDefaultInstitute",'myInstitute']),
    },
    mounted() {
        this.requestGetClasses();
        this.requestGetCenters();
		 const instiute = JSON.parse(localStorage.getItem('myInstitute'));
	  this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)
        // if (!this.signUpData) {
        //     this.$router.push({ name: "signup" });
        // }
    },
    watch: {
        selectedCenterId(val) {
            if (this.selectedCenterId) {
                this.showAddcenterButton = true;
                this.requestGetBatch(val);
            }
        },
        selectedCenterList(val) {
            let me = this;
            setTimeout(() => {
                me.testLogicForScroll();
            }, 100);
        },
        selectedSubject() {
            this.disableBatches();
        },
        ischecked() {
            this.error.ischecked.type = null;
        },
    },
};
</script>
